import { useMutation, useQuery } from '@tanstack/react-query';

import { Button, Card, Spinner } from '@design-system';

import { freemiumApi, freemiumKeys } from '@client/api/waterlily';
import { useIsFreemiumAdvisor } from '@/shared/hooks/use-freemium-advisor';

interface ManageUnlimitedSubscriptionProps {
  advisorId: string;
}
export function ManageUnlimitedSubscription({ advisorId }: ManageUnlimitedSubscriptionProps) {
  const isFreemiumAdvisor = useIsFreemiumAdvisor();
  const { data } = useQuery({
    queryKey: freemiumKeys.advisorAccess(advisorId),
    queryFn: () => freemiumApi.getAdvisorPlanningAccess(advisorId),
    enabled: !!advisorId && isFreemiumAdvisor,
  });

  const portalMutation = useMutation({
    mutationFn: () => freemiumApi.openUnlimitedBillingPortal(advisorId),
    onSuccess: result => {
      if (result.url) window.location.href = result.url;
    },
  });

  if (!data?.hasUnlimited) return null;

  return (
    <Card className="mb-6 p-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-medium text-gray-950">Unlimited self-serve access</p>
          <p className="text-foreground text-sm">$59/month · access for all of your clients</p>
        </div>
        <Button
          variant="outline"
          onClick={() => portalMutation.mutate()}
          disabled={portalMutation.isPending}
        >
          {portalMutation.isPending && <Spinner />}
          Manage subscription
        </Button>
      </div>
    </Card>
  );
}
